import { getPortalIcon } from '../utils/iconUtils';

/** Gradient icon box used on section headers across the User Dashboard */
const PortalSectionIcon = ({ iconName, variant = 'primary', className = '' }) => {
  const Icon = getPortalIcon(iconName);
  const gradient =
    variant === 'secondary'
      ? 'linear-gradient(135deg, var(--secondary-500), var(--secondary-600))'
      : 'linear-gradient(135deg, var(--primary-500), var(--primary-600))';

  return (
    <div
      className={`w-10 h-10 rounded-xl flex items-center justify-center shadow-lg shrink-0 ${className}`}
      style={{ background: gradient }}
    >
      <Icon className="w-5 h-5 text-white" />
    </div>
  );
};

export default PortalSectionIcon;
